import { cn } from "@/lib/utils";

export const OnboardingItemLayout = ({
  children,
  className,
}: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={cn(
        "overflow-hidden flex flex-col items-center justify-evenly w-full h-full px-6 relative",
        className,
      )}
    >
      {children}
    </div>
  );
};
